/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrdersStakeholderQuery } from '../../models/get-orders-stakeholder-query';
import { GetOrdersStakeholderQueryResult } from '../../models/get-orders-stakeholder-query-result';

export interface ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Params {
      body?: GetOrdersStakeholderQuery
}

export function apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersStakeholderQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrdersStakeholderQueryResult>;
    })
  );
}

apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost.PATH = '/api/NurseryManager/OrderStakeholder/GetOrdersStakeholder';
